module.exports = __webpack_public_path__ + "static/media/IOD_MapBkgrd.e85b53fa.jpg";